import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="select"
export default class extends Controller {
  static targets = ["input"]
  connect() {
    this.select = new TomSelect(this.inputTarget, {
      refreshThrottle: 100
    })
  }

  disconnect() {
    if(this.select) {
      this.select.destroy()
    }
  }
}
